// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 768px){.presentation-row{flex-wrap:nowrap}.presentation-row .col:nth-child(1){flex:auto;max-width:unset}.presentation-row .col:nth-child(2){flex:1;max-width:unset}}.presentation-row-cta{text-align:right}@media (max-width: 767.98px){.presentation-row-cta{text-align:center;margin-bottom:1rem}}\n", ""]);
// Exports
module.exports = exports;
